import { LoaderCircle } from 'lucide-react';
import styles from './Loading.module.css';

export function Spinner({ label = 'Wczytywanie…' }: { label?: string }) {
  return (
    <div className={styles.spinner} role="status">
      <LoaderCircle aria-hidden="true" className={styles.icon} />
      <span>{label}</span>
    </div>
  );
}

/** Full-screen placeholder while the app checks the session. */
export function LoadingScreen() {
  return (
    <div className={styles.screen}>
      <Spinner />
    </div>
  );
}
